import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { authenticateStripe, paymentActionOf } from '../stripe-checkout';

export const stripeInterceptor: HttpInterceptorFn = (req,next) => next(req).pipe(catchError(error=>{
  const action=error.status===409?paymentActionOf(error.error):null;
  if(!action || req.method!=='POST')return throwError(()=>error);
  return from(authenticateStripe(action)).pipe(switchMap(()=>
    from(new Promise(resolve=>setTimeout(resolve,action.type==='setup'?0:3500))).pipe(switchMap(()=>next(req)))
  ));
}));
